export var eventBus = {
    on: function (event, callback) {
        document.addEventListener(event, function (e) { return callback(e.detail); });
    },
    dispatch: function (event, data) {
        document.dispatchEvent(new CustomEvent(event, { detail: data }));
    },
    remove: function (event, callback) {
        document.removeEventListener(event, callback);
    },
};
//# sourceMappingURL=event-bus.js.map